export enum RemoteProperties {
  AFPSelfServe = 's4a-web-profile-artist-fundraising-pick-self-serve',
  AFPNewMarkets = 's4a-web-profile-artist-fundraising-pick-nz-latam-tr',
  ContextualActivityFeed = 's4a-web-profile-contextual-activity-feed',
  OneProduct = 's4a-web-profile-1p-rollout',
  SystemMaintenance = 's4a-web-profile-system-maintenance',
}
